$danger-color: #d03b3b;
$note-color: #c98500;

// matches CHART_INK.grid from shared/config/colors.jsx
$separator-color: rgba(137, 135, 129, 0.2);

//
//

.meal {
  margin: 1rem 0;

  &__sections {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  &__error {
    margin: 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.card {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: 1rem;
  background-color: var(--tg-theme-secondary-bg-color);

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    h2 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
    }
  }
}

//
//

.type {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0.65rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  white-space: nowrap;
  color: var(--tg-theme-subtitle-text-color);
  background-color: var(--tg-theme-bg-color);

  i {
    font-size: 0.75rem;
  }
}

.date {
  font-size: 0.8rem;
  text-align: right;
  color: var(--tg-theme-subtitle-text-color);
}

.title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.25;
}

.description {
  margin: 0.25rem 0 0;
  font-size: 0.9rem;
  color: var(--tg-theme-subtitle-text-color);
}

.count {
  min-width: 1.5rem;
  padding: 0.1rem 0.5rem;
  border-radius: 1rem;
  text-align: center;
  font-size: 0.8rem;
  color: var(--tg-theme-subtitle-text-color);
  background-color: var(--tg-theme-bg-color);
}

//
//

.calories {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;

  &__value {
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1;
  }

  &__unit {
    font-size: 0.95rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.split {
  display: flex;
  gap: 2px;
  height: 0.5rem;
  border-radius: 0.25rem;
  overflow: hidden;
  background-color: var(--tg-theme-bg-color);

  span {
    display: block;
    height: 100%;
  }
}

//
//

.macros {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.macro {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.6rem 0.65rem;
  border-radius: 0.65rem;
  background-color: var(--tg-theme-bg-color);

  &__name {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    color: var(--tg-theme-subtitle-text-color);
  }

  &__dot {
    flex-shrink: 0;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
  }

  &__value {
    font-size: 1rem;
    font-weight: 600;
  }

  &__percent {
    font-size: 0.75rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.note {
  display: flex;
  gap: 0.6rem;
  padding: 0.75rem;
  border-radius: 0.65rem;
  background-color: var(--tg-theme-bg-color);

  i {
    margin-top: 0.2rem;
    color: $note-color;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.45;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.items {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;

  &__empty {
    margin: 0;
    padding: 0.5rem 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }
}

.item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.65rem 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:first-child) {
    border-top: 1px solid $separator-color;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.75rem;
  }

  &__name {
    font-size: 0.95rem;
    font-weight: 500;
  }

  &__calories {
    font-size: 0.95rem;
    font-weight: 600;
    white-space: nowrap;
  }

  &__macros {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem 0.75rem;
    font-size: 0.8rem;
    color: var(--tg-theme-subtitle-text-color);

    span {
      display: inline-flex;
      align-items: center;
      gap: 0.3rem;
    }

    i {
      // ENABLE IF USE DOTS INSTEAD OF EMOJIS
      // width: 0.4rem;
      // height: 0.4rem;
      // border-radius: 50%;
    }
  }
}

//
//

.field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  &__label {
    font-size: 0.8rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--tg-theme-subtitle-text-color);
  }

  input,
  textarea {
    width: 100%;
    padding: 0.6rem 0.75rem;
    border: 1px solid transparent;
    border-radius: 0.65rem;
    font-size: 0.95rem;
    color: var(--tg-theme-text-color);
    background-color: var(--tg-theme-bg-color);
    transition: border-color 0.15s ease-in-out;

    &::placeholder {
      color: var(--tg-theme-subtitle-text-color);
    }

    &:focus {
      outline: none;
      border-color: var(--tg-theme-button-color);
    }
  }

  textarea {
    min-height: 3.25rem;
    resize: vertical;
  }
}

//
//

.types {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  // nested for specificity over the Btn wrapper design resets
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.3rem 0.75rem;
    border: 1px solid var(--tg-theme-subtitle-text-color);
    border-radius: 1rem;
    font-size: 0.85rem;
    color: var(--tg-theme-subtitle-text-color);

    i {
      font-size: 0.75rem;
    }

    &_active {
      border-color: var(--tg-theme-button-color);
      color: var(--tg-theme-button-text-color);
      background-color: var(--tg-theme-button-color);

      &:hover {
        opacity: 1;
      }

      // !important + higher specificity to beat the .btn_wrapper:active resets
      &:active {
        color: var(--tg-theme-button-text-color) !important;
        border-color: var(--tg-theme-button-color) !important;
        background-color: var(--tg-theme-button-color) !important;
      }
    }
  }
}

//
//

.edit-items {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.edit-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.65rem;
  background-color: var(--tg-theme-bg-color);

  // item inputs sit on the page background, so they get a visible border instead
  input {
    width: 100%;
    padding: 0.45rem 0.6rem;
    border: 1px solid $separator-color;
    border-radius: 0.5rem;
    font-size: 0.9rem;
    color: var(--tg-theme-text-color);
    background-color: var(--tg-theme-secondary-bg-color);
    transition: border-color 0.15s ease-in-out;

    &::placeholder {
      color: var(--tg-theme-subtitle-text-color);
    }

    &:focus {
      outline: none;
      border-color: var(--tg-theme-button-color);
    }
  }

  &__top {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  // nested for specificity over the Btn wrapper design resets
  .edit-item__remove {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    color: $danger-color;

    &:active {
      color: $danger-color !important;
    }
  }

  &__numbers {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.4rem;

    label {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    span {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 0.7rem;
      color: var(--tg-theme-subtitle-text-color);
    }

    i {
      width: 0.35rem;
      height: 0.35rem;
      border-radius: 50%;
    }

    input {
      padding: 0.4rem 0.45rem;
      text-align: center;
    }
  }
}

//
//

.card {
  // nested for specificity over the Btn wrapper design resets
  .add-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.4rem;
    width: 100%;
    padding: 0.55rem;
    border: 1px dashed var(--tg-theme-subtitle-text-color);
    border-radius: 0.65rem;
    font-size: 0.9rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.totals {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  padding: 0.6rem 0.75rem;
  border-radius: 0.65rem;
  font-size: 0.875rem;
  background-color: var(--tg-theme-bg-color);

  &__label {
    font-weight: 600;
  }

  &__values {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem 0.75rem;
    color: var(--tg-theme-subtitle-text-color);

    b {
      font-weight: 600;
      color: var(--tg-theme-text-color);
    }
  }
}

//
//

.actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &__main {
    width: 100%;
  }

  // nested for specificity over the Btn wrapper design resets
  .actions__cancel {
    align-self: center;
    padding: 0.35rem 1rem;
    color: var(--tg-theme-subtitle-text-color);
  }
}

//
//

.danger {
  padding: 0.5rem;

  // nested for specificity over the Btn wrapper design resets
  .danger__trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.55rem;
    border-radius: 0.65rem;
    font-size: 0.95rem;
    font-weight: 500;
    color: $danger-color;

    &:active {
      color: $danger-color !important;
    }
  }

  .danger__confirm {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    padding: 0.5rem;
  }

  .danger__question {
    margin: 0;
    text-align: center;
    font-weight: 600;
    color: var(--tg-theme-text-color);
  }

  .danger__hint {
    margin: 0;
    text-align: center;
    font-size: 0.85rem;
    color: var(--tg-theme-subtitle-text-color);
  }

  .danger__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    margin-top: 0.25rem;

    .danger__cancel {
      padding: 0.5rem;
      border-radius: 0.65rem;
      color: var(--tg-theme-text-color);
      background-color: var(--tg-theme-bg-color);

      &:active {
        color: inherit !important;
        background-color: var(--tg-theme-bg-color) !important;
      }
    }

    .danger__delete {
      padding: 0.5rem;
      border-radius: 0.65rem;
      color: #fff;
      background-color: $danger-color;

      &:hover {
        opacity: 0.85;
      }

      &:active {
        color: #fff !important;
        background-color: $danger-color !important;
      }
    }
  }
}
